import * as React from 'react'
import { faClose, FaIcon } from '@/lib/fa'
import { TextField } from '@/ui/form/controls/TextField'
import useVehicleService from '../../../services/VehicleService'
import { toast } from '@/lib/toasts/api'
import EditVehicleGroupDetailsModal from '../edit/EditVehicleGroupDetailsModal'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const AddVehicleGroupModal = ({
  close,
  companyId,
  refreshGroups,
  openGroupMembers = false,
  isEdit = false,
}) => {
  const { addVehicleGroup, getVehicleGroups } = useVehicleService()
  const { t } = useLocalize()

  const [newGroupName, setNewGroupName] = React.useState('')
  const [isAddGroupModelOpen, setIsAddGroupModelOpen] = React.useState(false)
  const [addedGroup, setAddedGroup] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  const addVehicleGroupHandler = async () => {
    setLoading(true)
    try {
      await addVehicleGroup({ companyId: companyId, name: newGroupName })
      toast.success({
        text: t('vehicleModule.group-added'),
      })
      if (openGroupMembers) {
        await getVehicleGroups({ companyId: companyId }).then((groups) => {
          setAddedGroup(groups.find((g) => g.name === newGroupName))
          setIsAddGroupModelOpen(true)
        })
      }
    } catch (err) {
      toast.error({
        text: t('vehicleModule.error-adding-group'),
      })
    } finally {
      setLoading(false)
      refreshGroups()
    }
  }

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-overflow-auto tw-overflow-y-auto tw-bg-content-base tw-bg-opacity-70">
      <div className="tw-flex tw-max-h-[500px] tw-w-full tw-max-w-[480px] tw-flex-col tw-justify-between tw-rounded-lg tw-bg-white">
        <div className="tw-flex tw-items-center tw-justify-between tw-p-4">
          <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
            {isEdit ? t('vehicleModule.edit-group') : t('vehicleModule.add-new-group')}
          </p>
          <FaIcon
            icon={faClose}
            className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer"
            onClick={() => close()}
          />
        </div>
        <div className="tw-p-4 tw-pt-0">
          <TextField
            disabled={loading}
            label={t('vehicleModule.group-name')}
            required
            placeholder={t('vehicleModule.placeholder-group-name')}
            value={newGroupName}
            onChange={(e) => setNewGroupName(e.target.value)}
          />
        </div>
        <div className="tw-flex tw-items-center tw-justify-end tw-border-t tw-border-base-300 tw-px-4">
          <div className="tw-my-4 tw-flex tw-items-center tw-gap-3">
            <button
              disabled={loading}
              type="button"
              onClick={() => addVehicleGroupHandler()}
              className={`tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80`}
            >
              {isEdit ? t('common.confirm') : t('vehicleModule.add-group')}
            </button>
          </div>
        </div>
      </div>
      {isAddGroupModelOpen && newGroupName && (
        <EditVehicleGroupDetailsModal
          companyId={companyId}
          group={addedGroup}
          close={() => close()}
        />
      )}
    </div>
  )
}
export default AddVehicleGroupModal
